import { render, staticRenderFns } from "./ChatRatingTicketMessage.vue?vue&type=template&id=543deb02&scoped=true&"
import script from "./ChatRatingTicketMessage.vue?vue&type=script&lang=js&"
export * from "./ChatRatingTicketMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatRatingTicketMessage.vue?vue&type=style&index=0&id=543deb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543deb02",
  null
  
)

export default component.exports